import React from 'react'
interface IProps {}

const Badge: React.FC<IProps> = ({children}) => {
  return <div className="badge px-1">{children}</div>
}

export default Badge
